export const clearEmptyValues = (obj: object): object => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        return [key, clearEmptyValues(value as object)];
      }

      if (typeof value === 'string') {
        const trimmedValue = value.trim();
        return trimmedValue === '' ? [key, null] : [key, trimmedValue];
      }

      return [key, value];
    })
  );
};

export const clearNullValues = (obj: object): object => {
  return Object.fromEntries(Object.entries(obj).map(([i, v]) => (v === null ? [i, ''] : [i, v])));
};
